import { Injectable } from '@angular/core';
import { Observable, tap, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Comprovante, IComprovante, ConsultaTransacaoDetalhe,IConsultaTransacaoDetalhe,ConsultaTransacao, IConsultaTransacao, InfoTransacaoModel, InfoTransacaoModelResponse, ITransacoes, Transacoes } from '../subFrota/model/abastecimentos-view-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from '../services/localstorage.service';
import { SnackBarService } from '../services/snack-bar-service.service';
import { LoginModel } from '../model/login.model';
import { IFiltroRegistroTransacoesViewModel } from '../relatorios/model/filtro-transacoes-view-model';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class RegistroTransacoesService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  public usuario!: LoginModel;


  constructor(private http: HttpClient,
    private localStorageService: LocalStorageService,
    private snackBar: SnackBarService) {

    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  
  private handleError<T>(mensagem = 'Não foi possível realizar a operação.', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.flashMessage(mensagem, ['snackbar-error'], 'Fechar', 0);

      return of(result as T);
    };
  }
  
  obterListaTransacoes(filtro: IFiltroRegistroTransacoesViewModel): Observable<ITransacoes>{
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListaRegistroOperacoes;

    return this.http.post<ITransacoes>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar as transacoes da Frota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<ITransacoes>('Não foi possível consultar as transacoes da Frota.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  obterImagemTransacao(data: InfoTransacaoModel): Observable<InfoTransacaoModelResponse> {
    const url = environment.host_ctf_service + CONFIG_URLS_API.API_ObterImagemTransacao;

    return this.http.post<InfoTransacaoModelResponse>(url, data, this.httpOptions).pipe(
      tap((response: InfoTransacaoModelResponse) => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível obter a imagem do Hodômetro.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<InfoTransacaoModelResponse>(
        'Não foi possível obter a imagem do Hodômetro.',
        { sucesso: false, retorno: undefined, mensagens: [] }
      ))
    );
  }

  obterConsultaTransacao(consulta: any): Observable<IConsultaTransacao> {
    const consultaParams = {
      COD_TRANSACAO: consulta.coD_TRANSACAO || consulta.COD_TRANSACAO,
      COD_AUTORIZACAO: consulta.coD_AUTORIZACAO || consulta.COD_AUTORIZACAO,
      COD_FROTA: consulta.coD_FROTA || consulta.COD_FROTA,
      COD_POSTO: consulta.coD_POSTO || consulta.COD_POSTO
    };

    const url = environment.host_ctf_service + CONFIG_URLS_API.API_ConsultaTransacao;

    return this.http.post<IConsultaTransacao>(url, consultaParams, this.httpOptions).pipe(
      tap((response: IConsultaTransacao) => { 
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível acessar a consulta.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaTransacao>(
        'Erro ao recuperar consulta.', 
        { sucesso: false, retorno: [], mensagens: [] }
      ))
    );
  }

  obterConsultaTransacaoDetalhe(consultadetalhe: any): Observable<IConsultaTransacaoDetalhe> {
    const consultaParams = {
      COD_TRANSACAO: consultadetalhe.coD_TRANSACAO || consultadetalhe.COD_TRANSACAO,
      COD_AUTORIZACAO: consultadetalhe.coD_AUTORIZACAO || consultadetalhe.COD_AUTORIZACAO,
      COD_FROTA: consultadetalhe.coD_FROTA || consultadetalhe.COD_FROTA,
      COD_POSTO: consultadetalhe.coD_POSTO || consultadetalhe.COD_POSTO
    };

    const url = environment.host_ctf_service + CONFIG_URLS_API.API_ConsultaTransacaoDetalhe;

    return this.http.post<IConsultaTransacaoDetalhe>(url, consultaParams, this.httpOptions).pipe(
      tap((response: IConsultaTransacaoDetalhe) => { 
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível acessar a consulta de detalhes da transação.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaTransacaoDetalhe>(
        'Erro ao recuperar detalhes da consulta de transação.', 
        { sucesso: false, retorno: [], mensagens: [] }
      ))
    );
  }

    comprovante(comprovante: any): Observable<IComprovante> {
    const consultaParams = {
      COD_TRANSACAO: comprovante.coD_TRANSACAO || comprovante.COD_TRANSACAO,
      COD_ABASTECIMENTO: comprovante.coD_ABASTECIMENTO || comprovante.COD_ABASTECIMENTO,
    };

    const url = environment.host_ctf_service + CONFIG_URLS_API.API_Comprovante;

    return this.http.post<IComprovante>(url, consultaParams, this.httpOptions).pipe(
      tap((response: IComprovante) => { 
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível acessar o comprovante da transação.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IComprovante>(
        'Erro ao recuperar o comprovante da transação.', 
        { sucesso: false, retorno: [], mensagens: [] }
      ))
    );
  }

}
